import { FC, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CurrentViewContext } from '../../../providers/CurrentViewProvider';
import CommentGeneratorComponent from '../../../components/AICommentGenerator/AICommentGenerator';
import { Box, useTheme } from '@mui/material';
import Section from '../../../components/Main/Section/Section';
import { ReactComponent as AIGeneratorImage } from '../../../assets/images/ai_reviews.svg';

const AICommentGenerator: FC = () => {
  const { t } = useTranslation();
  const { setCurrentView } = useContext(CurrentViewContext);
  const theme = useTheme();

  useEffect(() => {
    setCurrentView(t('nav_ai_commentgenerator'));
    document.title = `${t('app_branding')} ${t('nav_ai_commentgenerator')}`;
  }, [setCurrentView, t]);

  return (
    <Section>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          borderRadius: `${theme.shape.borderRadius}px`,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <AIGeneratorImage width="300" />
        <Box sx={{ mt: theme.spacing(4), maxWidth: 800 }}>
          <CommentGeneratorComponent />
        </Box>
      </Box>
    </Section>
  );
};

export default AICommentGenerator;
